import { Box, Paper, Skeleton, Stack, Typography } from "@mui/material";

type Props = {
  title: string;
  isLoading: boolean;
  children: React.ReactNode;
  height?: number;
  action?: React.ReactNode;
};

export const ChartCard = ({
  title,
  isLoading,
  children,
  height,
  action,
}: Props): React.ReactNode => {
  return (
    <Paper
      sx={{
        bgcolor: "background.default",
        border: (theme) => `1px solid ${theme.colors.border}`,
        borderRadius: 2,
        p: 3,
        height: height ? height + 80 : "auto",
        display: "flex",
        flexDirection: "column",
        outline: "none",
        "&:focus": { outline: "none" },
        "&:focus-visible": { outline: "none" },
      }}
      elevation={0}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Typography
          variant="subtitle2"
          sx={{ color: "text.secondary", fontWeight: 600 }}
        >
          {title}
        </Typography>
        {action}
      </Stack>

      {isLoading ? (
        <Box flex={1} display="flex" flexDirection="column" gap={1}>
          <Skeleton
            variant="rectangular"
            height={height ?? 200}
            sx={{ borderRadius: 1, bgcolor: "action.hover" }}
          />
        </Box>
      ) : (
        <Box
          flex={1}
          sx={{
            "& *": {
              outline: "none !important",
            },
          }}
        >
          {children}
        </Box>
      )}
    </Paper>
  );
};
